/* eslint-disable import/prefer-default-export */
import { Beneficiary } from 'types';
import beneficiaryStatus from 'constants/beneficiaryStatus';

export const getBeneficiaryStatus = (beneficiary: Beneficiary): string => {
  if (beneficiary?.isPaused) {
    return beneficiaryStatus.var.PAUSED;
  }

  if (beneficiary?.isCanceled) {
    return beneficiaryStatus.var.CANCELED;
  }

  if ((beneficiary?.percentConsolidated || 0) < 100) {
    return beneficiaryStatus.var.ACTIVE;
  }

  return beneficiaryStatus.var.CONSOLIDATED;
};
